import React from 'react';
import PropTypes from 'prop-types';

import { InsOutsPlayer } from './InsOutsPlayer';

/**
 * Renders the wrapper and title for a single team.
 *
 * @param data.data
 * @param {object} data The Ins/Outs player data.
 * @param {string} title The value printed to the section, i.e. 'IN' or 'OUT'.
 * @param {string} matchTitle The match title, e.g. 'Sydney Swans v GWS GIANTS'.
 * @param {string} cssClass The CSS class that is applied to the title, i.e. 'in' or 'out'.
 * @param {string} teamDisplay The team to display, i.e. 'home' or 'away'.
 * @param data.title
 * @param data.cssClass
 * @param data.teamDisplay
 * @param data.matchTitle
 * @returns {JSX.Element} The Ins/Outs row for a single team.
 */
export const InsOutsRowSingle = ({
    data,
    title,
    matchTitle,
    cssClass,
    teamDisplay
}) => {
    const renderPlayer = (item, match) => {
        if (!item) {
            return null;
        }

        const player = item.player ? item.player : item;

        return (
            <InsOutsPlayer
                key={player.playerId}
                data={data}
                player={player}
                reason={item.reason}
                match={match}
                matchTitle={matchTitle}
            />
        );
    };

    return (
        <div className="team-lineups-condensed-embeddable__ins-and-outs">
            <div className="team-lineups-condensed-embeddable__ins-and-outs-single">
                <div className="team-lineups-condensed-embeddable__ins-and-outs-single-label">
                    <div className="team-lineups-ins-and-outs__title-wrapper">
                        <p
                            className={`team-lineups-ins-and-outs__title ${
                                cssClass
                                    ? `team-lineups-ins-and-outs__title--${cssClass}`
                                    : ''
                            }`}
                        >
                            {title}
                        </p>
                    </div>
                </div>
                <div className="team-lineups-condensed-embeddable__ins-and-outs-single-value">
                    {teamDisplay === 'home' ? (
                        data.home.length ? (
                            <div className="team-lineups-ins-and-outs__grid team-lineups-ins-and-outs__grid--home">
                                {[...data.home]
                                    .reverse()
                                    .map((item) =>
                                        renderPlayer(item, data.match)
                                    )}
                            </div>
                        ) : (
                            <span className="team-lineups-ins-and-outs__empty team-lineups-ins-and-outs__empty--home">
                                &ndash;
                            </span>
                        )
                    ) : teamDisplay === 'away' ? (
                        data.away.length ? (
                            <div className="team-lineups-ins-and-outs__grid team-lineups-ins-and-outs__grid--away">
                                {data.away.map((item) =>
                                    renderPlayer(item, data.match)
                                )}
                            </div>
                        ) : (
                            <span className="team-lineups-ins-and-outs__empty team-lineups-ins-and-outs__empty--away">
                                &ndash;
                            </span>
                        )
                    ) : null}
                </div>
            </div>
        </div>
    );
};

InsOutsRowSingle.propTypes = {
    data: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
    matchTitle: PropTypes.string.isRequired,
    cssClass: PropTypes.string,
    teamDisplay: PropTypes.string.isRequired
};
